window.currentPage = 1

function getQueryForCollectionPagination(sectionId) {
  const params = new URLSearchParams(window.location.search)
  let query = ''

  for (let p of params) {
    if (p[0] !== 'page') {
      if (query !== '') {
        query += '&'
      }

      query += `${p[0]}=${p[1]}`
    }
  }

  const partQuery = `?section_id=${sectionId}&page=${window.currentPage}${query !== '' ? '&' : ''}`

  return partQuery + query
}

function loadNextPage() {
  const sectionId = document.getElementById('main-collection-product-grid').dataset.id
  window.currentPage++
  const query = getQueryForCollectionPagination(sectionId)
  fetch(query)
    .then(response => response.text())
    .then((responseText) => {
      const html = new DOMParser()
        .parseFromString(responseText, 'text/html')
        .querySelector(`[id*="${sectionId}"]`).innerHTML
      this.renderProductGrid(html)
    })
}

function renderProductGrid(html) {
  const content = new DOMParser().parseFromString(html, 'text/html')
  const productGrid = content.getElementById('main-collection-product-grid')
  const innerHTML = productGrid.innerHTML
  const itemsFetched = parseInt(content.querySelector('.js-product-count').innerHTML)
  const totalProducts = parseInt(content.querySelector('.js-total-product-count').innerHTML)

  document.querySelector('.js-product-count').innerHTML = itemsFetched >= totalProducts ? totalProducts : itemsFetched
  if (productGrid.querySelector('li')) {
    document.getElementById('main-collection-product-grid').insertAdjacentHTML('beforeend', innerHTML)
  }
  if (itemsFetched >= totalProducts) {
    document.querySelector('.js-collection-load-more').style.display = 'none'
  }

  const searchParams = new URLSearchParams(window.location.search).toString()
  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
}

document
  .querySelector('.js-collection-product-grid')
  .addEventListener('click', e => {
    const target = e.target

    if (target.classList && target.classList.contains('js-collection-load-more')) {
      loadNextPage()
    }
  })
